import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useTextAreaContext } from './context.mjs';
import { styledFooter } from './footer.vanilla.mjs';

const Footer = forwardRef(
  ({ className: classNameFromProps, ...props }, ref) => {
    const { onFooterElementChange } = useTextAreaContext("TextArea.Footer");
    const composedRef = useComposedRefs(ref, onFooterElementChange);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        className: classNames(styledFooter, classNameFromProps),
        ref: composedRef,
        ...props
      }
    );
  }
);

export { Footer as default };
//# sourceMappingURL=Footer.mjs.map
